export enum Errors {
  UNKNOWN_ERROR = 'Unknown error',
}
